import axios from 'axios';

const API_URL = 'https://sportokrantas.lt/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Events API
export const eventsApi = {
  getAll: () => api.get('/events'),
  getById: (id) => api.get(`/events/${id}`),
};

// Registrations API
export const registrationsApi = {
  create: (data) => api.post('/registrations', data),
};

export default api;
